export default () => ({
    app: {
        loading: false,
        notifications: {
            target: null,
            items: [],
        },
        showValidationErrorNotes: true,
        auth: null,
        products: [],
        removedItems: [],
        cartLinkedProducts: [],
        productLinkedProducts: []
    },
    share_cart: {
        to: _configs.share_recipients,
        redirectTo: 'cart',
        cc: null,
        from: null,
        fromName: null,
        subject: _configs.share_email_subject,
        description: null,
        phone: null,
        state: null,
        zipcode: null,
        popup_description: _configs.share_popup_description,
    },
    cart: {
        items: [],
        hash: null,
        coupon: null,
        cart_type: 0,
    },
    billing_info: {
        billing_first_name: null,
        billing_last_name: null,
        billing_company_name: null,
        billing_country: 'US',
        billing_street_address1: null,
        billing_street_address2: null,
        billing_city: null,
        billing_state: null,
        billing_zipcode: null,
        billing_phone_number: null,
        billing_email_address: null,
        order_notes: null,
        same_as_billing: 1,
        read_and_accept: 0
    },
    shipping_info: {
        shipping_first_name: null,
        shipping_last_name: null,
        shipping_company_name: null,
        shipping_country: 'US',
        shipping_street_address1: null,
        shipping_street_address2: null,
        shipping_city: null,
        shipping_phone_number: null,
        shipping_state: null,
        shipping_zipcode: null,
        shipping_email_address: null,
    },
    shipping_methods: {
        state: null,
        zipcode: null,
        email: null,
        rates: [],
        selected: null,
        country: 'US',
        custom_price: null,
        defaultCost: null
    },
    before_shipping_methods: {
        state: null,
        zipcode: null,
        email: null,
        rates: [],
        selected: null,
        country: 'US',
        custom_price: null,
        defaultCost: null,
        shipFree: null
    },
    data_layer_default:
    {
        customerBillingAddress1:"",
        customerBillingAddress2:"",
        customerBillingCity:"",
        customerBillingCompany:"",
        customerBillingCountry:"",
        customerBillingEmail:"",
        customerBillingEmailHash:"e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
        customerBillingFirstName:"",
        customerBillingLastName:"",
        customerBillingPhone:"",
        customerBillingPostcode:"",
        customerFirstName:"",
        customerLastName:"",
        customerShippingAddress1:"",
        customerShippingAddress2:"",
        customerShippingCity:"",
        customerShippingCompany:"",
        customerShippingCountry:"",
        customerShippingFirstName:"",
        customerShippingLastName:"",
        customerShippingPostcode:"",
        customerTotalOrderValue:"0.00",
        customerTotalOrders:0,
        ecommerce:
        {
            cart:[],
            currencyCode:"",
            impressions:[]
        }
    },
    data_layer_view_cart:
    {
        ecommerce:
        {
            currency: "USD",
            items: [],
            value: "0.00"
        },
        event: "view_cart"
    },
    data_layer_view_item:
    {
        ecommerce:
        {
            currency: "USD",
            items: [],
            value: "0.00"
        },
        event: "view_item"
    },
    data_layer_add_to_cart:
    {
        ecommerce:
        {
            currency: "USD",
            items: [],
            value: "0.00"
        },
        event: "add_to_cart"
    },
    data_layer_change_detail_view_eec:
    {
        ecomm_pagetype: "product",
        ecomm_prodid: "",
        ecomm_totalvalue: "0.00",
        ecommerce:
        {
            currencyCode : "USD",
            detail:
            {
                products: [],
            },
        },
        event: "gtm4laravel.changeDetailViewEEC"
    },
    data_layer_add_product_to_cart_eec:
    {
        ecommerce:
        {
            add:
            {
                products: [],
            },
            currencyCode: "USD",
        },
        event: "gtm4laravel.addProductToCartEEC"
    },
    data_layer_remove_from_cart:
    {
        ecommerce:
        {
            currency: "USD",
            items: [],
            value: "0.00"
        },
        event: "remove_from_cart"
    },
    data_layer_add_remove_from_cart_eec:
    {
        ecommerce:
        {
            remove:
            {
                products: [],
            },
            currencyCode: "USD",
        },
        event: "gtm4wp.removeFromCartEEC"
    },
    data_layer_checkout_default:
    {
        customerBillingAddress1:"",
        customerBillingAddress2:"",
        customerBillingCity:"",
        customerBillingCompany:"",
        customerBillingCountry:"",
        customerBillingEmail:"",
        customerBillingEmailHash:"e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
        customerBillingFirstName:"",
        customerBillingLastName:"",
        customerBillingPhone:"",
        customerBillingPostcode:"",
        customerFirstName:"",
        customerLastName:"",
        customerShippingAddress1:"",
        customerShippingAddress2:"",
        customerShippingCity:"",
        customerShippingCompany:"",
        customerShippingCountry:"",
        customerShippingFirstName:"",
        customerShippingLastName:"",
        customerShippingPostcode:"",
        customerTotalOrderValue:"0.00",
        customerTotalOrders:0,
        ecommerce:
        {
            checkout:
            {
                actionField:
                {
                    step: "1"
                },
                products: []
            },
            currencyCode:"USD",
            event: "gtmlaravel.checkoutStepEEC"
        }
    },
    data_layer_begin_checkout:
    {
        ecommerce:
        {
            currency: "USD",
            items: [],
            value: "0.00"
        },
        event: "begin_checkout"
    }
})
